module.exports = __webpack_public_path__ + "img/history-reminder.05d0d547.png";